import * as api from '../../api/carga-masiva-client';
import { 
    GET_CARGAS_PREVIAS,
    POST_CARGAR_ARCHIVO
} from '../types';


export const cargasPreviasAction = (query) => ({
    type: GET_CARGAS_PREVIAS,
    payload: api.getCargasPrevias(query)
});

export const cargarArchivoAction = (file) => ({
    type: POST_CARGAR_ARCHIVO,
    payload: api.postCargarArchivo(file)
})